<script setup>
import { ref, defineProps, computed, inject } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
const modules = [Pagination];
const DLEvent = inject('DLEvent');
const props = defineProps({
  catalog: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: ''
  },
  isAdult: {
    type: Boolean,
    default: false
  }
})

const swiperOptions = computed(() => {
  return {
    modules: modules,
    slidesPerView: 1,
    spaceBetween: 24,
    centerInsufficientSlides: true,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      '720': {
        spaceBetween: 16,
        slidesPerView: 'auto',
      },
      '1024': {
        spaceBetween: 16,
        slidesPerView: 3,
      }
    },
  }
})
const ageTitle = props.isAdult ? 'собак' : 'щенков';
const switcher = [
  {id: 'small', title: `Для ${ageTitle} мелких и&nbsp;карликовых пород`},
  {id: 'medium', title: `Для ${ageTitle} средних пород`},
  {id: 'big-athlete', title: `Для ${ageTitle} крупных пород с&nbsp;атлетическим телосложением`},
  {id: 'big-strong', title: `Для ${ageTitle} крупных пород с&nbsp;Мощным телосложением`}
]

const labels = {
  skin: {title: 'чувствительная кожа', color: '#BD4F7B'},
  digestion: {title: 'Чувствительное пищеварение', color: '#148172'},
  everyday: {title: 'Ежедневный рацион', color: '#EC6600'},
  picky: {title: 'привередливость в питании', color: '#8E592F'},
  start: {title: 'Здоровый старт', color: '#779C5A'}
}
const selectedType = ref('small');
const swiperInstances = ref({});

const onSwiper = (id, swiper) => {
  swiperInstances.value[id] = swiper;
}

const selectType = (id) => {
  selectedType.value = id;
  swiperInstances.value[id]?.slideTo(0, 0);
  DLEvent(
      props.isAdult ? 'puppyPage_switch_dog_breed' : 'puppyPage_switch_puppy_breed',
      props.isAdult ? 'dog_breed' : 'puppy_breed',
      switcher.find(item => item.id === id).title.replace('&nbsp;', ' ')
  );
}

const getFilteredProducts = (id) => {
  return props.catalog.filter(product => product.type === id);
}
</script>
<template>
  <div :class="['ration-block', {'ration-block_alt': isAdult}]">
    <div class="ration-block__inner">
      <h4 class="ration-block__pretitle" v-if="isAdult">По достижении взрослого возраста</h4>
      <h2 class="ration-block__title" v-html="title"></h2>
      <div class="ration-block__switcher">
        <div
            class="ration-block__switcher-item"
            v-for="item in switcher"
            :key="item.id"
            @click="selectType(item.id)"
        >
          <img :src="require(`@/assets/img/icon-${item.id}.svg`)" alt="" v-show="item.id !== selectedType"/>
          <img :src="require(`@/assets/img/icon-${item.id}-a.svg`)" alt="" v-show="item.id === selectedType"/>
        </div>
      </div>
      <h3 class="ration-block__subtitle" v-html="switcher.find(obj => obj.id === selectedType).title"></h3>
      <template v-for="products in switcher" :key="products.id">
        <Swiper
            v-bind="swiperOptions"
            v-show="selectedType === products.id"
            class="ration-block__products-slider"
            @swiper="onSwiper(products.id, $event)"
        >
          <SwiperSlide v-for="productItem in getFilteredProducts(products.id)" :key="productItem.id">
            <a
                :href="productItem.link"
                class="product-card"
                target="_blank"
                @click="DLEvent('puppyPage_product_button', 'product_URL', productItem.link)"
            >
              <span class="product-card__new" v-if="productItem.isNew">Новинка</span>
              <span class="product-card__label" :style="{'background-color': labels[productItem.label].color}">{{ labels[productItem.label].title }}</span>
              <div class="product-card__image">
                <img :src="require(`@/assets/img/pack-${productItem.id}.png`)" alt=""/>
                <template v-if="!isAdult">
                  <img src="@/assets/img/icon-puppy2.svg" alt="" class="_label" v-if="productItem.type === 'big-athlete' || productItem.type === 'big-strong'"/>
                  <img src="@/assets/img/icon-puppy.svg" alt="" class="_label" v-else />
                </template>
              </div>
              <h4 class="product-card__title" v-html="productItem.title"></h4>
              <span class="product-card__button">Подробнее</span>
            </a>
          </SwiperSlide>
          <template #pagination></template>
        </Swiper>
      </template>

      <div class="ration-block__info" v-if="!isAdult">
        <div>
          <img src="@/assets/img/icon-info1.svg" alt="" />
          <p>Рационы разработаны для&nbsp;щенков<br/> с&nbsp;6&nbsp;недель до&nbsp;24&nbsp;месяцев <br class="_visible-mobile"/>в&nbsp;зависимости<br class="_hidden-mobile"/> от&nbsp;размера породы</p>
        </div>
        <div>
          <img src="@/assets/img/icon-info2.svg" alt="" />
          <p>Рационы также подходят<br/> для&nbsp;беременных<br/> и&nbsp;кормящих собак</p>
        </div>
      </div>
    </div>
  </div>
</template>